const $doc = $(document);
const $html = $("html");

if ($("input#cart-note").length) {
  let value = $("input#cart-note").val();

  $.ajax({
    url: "/cart/update.js",
    type: "POST",
    dataType: "JSON",
    data: "attributes[Cart Note]=" + value
  });
}

$doc
  .on("mouseup", function(e) {
    e.preventDefault();

    clickOutside(
      $(".cart-expanded .cart-wrapper, .cart-expanded .cart-trigger-js"),
      e
    );
  })
  .on("mouseenter mouseleave", ".cart-trigger-js-parent", function(e) {
    e.preventDefault();

    if (e.type === 'mouseenter') {
      $html.addClass("cart-expanded");
    }

    if (e.type === 'mouseleave') {
      $html.removeClass("cart-expanded");
    }
  })
  .on("submit", 'form[action="/cart/add"]', function(e) {
    e.preventDefault();
    addToCart($(this));
  })
  .on("click", ".product__qty .btn-qty", function(e) {
    e.preventDefault();
    updateQty($(this));
  })
  .on("change", ".field--quantity", function(e) {
    const $form = $(this).closest("form");
    updateCart($form);
  })
  .on("change", "#field-note", function(e) {
    const $this = $(this);

    $.ajax({
      url: "/cart/update.js",
      type: "POST",
      dataType: "JSON",
      data: "note=" + $this.val()
    });
  })
  .on("click", ".remove", function(e) {
    e.preventDefault();
    const href = $(this).attr("href");

    removeProduct(href);
  });

function removeProduct($this) {
  $.post($this).done(data => {
    const hideCart = $(data).find('.cart-wrapper .table--cart').length === 0;
    changeCartData(data, false, hideCart);
  });
}

// Update Product Quantity //
function updateQty($btn) {
  const $productQty = $btn.closest(".product__qty");
  const $input = $productQty.find(".field--quantity");
  const step = parseInt($btn.data("step"));
  let val = parseInt($input.val());

  val += step;

  if (val > 0) {
    $input.val(val).change();
  }
}

// Add product to cart with Ajax //
function addToCart($form) {
  const serializeForm = $form.serialize();
  const $cartTrigger = $('.cart-trigger-js');
  const cartDelay = parseInt($cartTrigger.data('close_delay')) * 1000;

  $.ajax({
    type: "POST",
    url: "/cart/add",
    dataType: "html",
    data: serializeForm,
    success: response => {
      $("#add").addClass("added");
      $('.cart-wrapper').addClass('added');

      setTimeout(() => {
        $("#add").removeClass("added");
        $('.cart-wrapper').removeClass('added');
      }, cartDelay);

      changeCartData(response, true);
    },
    error: data => {
      $(".product--single .product__hint").fadeIn();

      setTimeout(() => {
        $(".product--single .product__hint").fadeOut();
      }, 5000);
    }
  });
}

function updateCart($form) {
  const serializeForm = $form.serialize();

  $.ajax({
    url: "/cart/update.js",
    data: serializeForm,
    dataType: "json"
  }).done(() => {
    updateCartContent();
  });
}

function updateCartContent(expandCart = false) {
  $.ajax({
    url: "/cart"
  }).done(response => {
    changeCartData(response);

    if (expandCart) {
      $html.addClass("cart-expanded");

      if (window.cartPopupDelay) {
        setTimeout(() => {
          $html.removeClass("cart-expanded");
        }, window.cartPopupDelay);
      }
    }
  });
}

function clickOutside($container, e) {
  const toggleClass = $container.data("toggle-class");

  if (!$container.is(e.target) && $container.has(e.target).length === 0) {
    $html.removeClass(toggleClass);
  }
}

function changeCartData(data, expandCart = false, hideCart = false) {
  const $count = $(data).find(".cart-trigger-js .count");
  const $formNew = $(data).find(".section-cart form");
  const $formBodyNew = $formNew.find(".form__body");
  const $totalNew = $formNew.find(".table__total-label .price");

  $(".table__total-label .price").each(function() {
    $(this).html($totalNew.html());
  });

  $(".cart-trigger-js .count").each(function() {
    $(this).text($count.text());
  });

  if ($(".header .cart-wrapper__content")) {
    $(".header .cart-wrapper__content").html($formBodyNew.html());
  }
  if ($(".section-cart .form__body").length) {
    $(".section-cart .form__body").html($formBodyNew.html());
  }

  if (expandCart) {
    $html.addClass("cart-expanded");

    if (window.cartPopupDelay) {
      setTimeout(() => {
        $html.removeClass("cart-expanded");
      }, window.cartPopupDelay);
    }
  }

  if (hideCart) {
    $html.removeClass("cart-expanded");
  }
}
